<template>
  <article>
    <div class="d-flex justify-content-end mb-4">
      <button @click="unactivateSquad()" v-if="travel_squad === 1" class="btn btn-danger">Desactivar Travel Squad</button>
      <button @click="activateSquad()" v-else class="btn btn-success">Activar Travel Squad</button>
    </div>
    <div class="form-content">
      <!-- <circle-spin v-if="is_loading"></circle-spin> -->
      <div class="table-ship">
        <data-table
          :columns="columns"
          :sortKey="sortKey"
          :sortOrders="sortOrders"
          @sort="sortBy"
          v-if="is_loading == false"
        >
          <tbody class="kt-datatable__body">
            <span v-for="data in viajes" :key="data.id">
              <tr class="kt-datatable__row">
                <td class="td-table">
                  <span class="span-title">{{ data.origin }}</span>
                </td>
                <td class="td-table">
                  <span class="span-title">{{ data.destination }}</span>
                </td>
                <td class="td-table">
                  <span class="span-title"> {{ data.arrival_date }}</span>
                </td>
              </tr>
            </span>
          </tbody>
        </data-table>
      </div>

      <pagination
        :pagination="pagination"
        @changePagination="getViajes"
        v-if="is_loading == false"
      ></pagination>
    </div>
  </article>
</template>
<script>
import DataTable from "@/components/views/DataTable.vue";
import Pagination from "@/components/views/Pagination.vue";
import axios from "axios";
export default {
  props: ["idUser", "travelSquad"],
  components: { DataTable, Pagination },
  created() {
    this.getViajes();
  },
  data() {
    let sortOrders = {};
    let columns = [
      { label: "Origen", name: "origin", visible: true },
      { label: "Destino", name: "destination", visible: true },
      { label: "Arrival Date ", name: "arrival_date", visible: true },
    ];
    columns.forEach((column) => {
      sortOrders[column.name] = -1;
    });
    return {
      viajes: null,
      columns,
      sortKey: "updated_at",
      sortOrders: sortOrders,
      filterKey: "",
      tableData: {
        orderBy: "created_at",
        length: 4,
        page: 1,
      },
      pagination: {
        lastPage: "",
        currentPage: "",
        total: "",
        lastPageUrl: "",
        nextPageUrl: "",
        prevPageUrl: "",
        from: "",
        to: "",
      },
      is_loading: true,
      travel_squad: this.travelSquad,
    };
  },
  methods: {
    getViajes(page) {
      this.is_loading = true;
      //   this.tableData.draw++;
      this.tableData.page = page;
      let url = process.env.API_URL + "/api/client/" + this.idUser + "/listTravels";

      // eslint-disable-next-line no-unreachable
      axios
        .get(url, { params: this.tableData })
        .then((response) => {
          this.viajes = response.data.body.data;
          this.is_loading = false;
          this.configPagination(response.data.body);
        })
        .catch((error) => {
          console.log(error, "No se obtuvieron resultados");
          this.is_loading = false;
          return;
        });
    },
    cleanInput() {
      this.tableData.filterValue = "";
    },
    configPagination(data) {
      this.pagination.lastPage = data.last_page;
      this.pagination.currentPage = data.current_page;
      this.pagination.total = data.total;
      this.pagination.lastPageUrl = data.last_page_url;
      this.pagination.nextPageUrl = data.next_page_url;
      this.pagination.prevPageUrl = data.prev_page_url;
      this.pagination.from = data.from;
      this.pagination.to = data.to;
      this.pagination.perPage = this.tableData.length;
    },
    sortBy(key) {
      this.sortKey = key;
      this.sortOrders[key] = this.sortOrders[key] * -1;
      this.tableData.orderBy = this.sortOrders;
      /* this.tableData.orderBy = this.getIndex(this.columns, 'name', key) */

      this.tableData.dir = this.sortOrders[key] === 1 ? "asc" : "desc";

      this.getPedidos();
    },
    getIndex(array, key, value) {
      return array.findIndex((i) => i[key] === value);
    },
    activateSquad() {
      const URL =`${process.env.API_URL}/api/client/${this.idUser}/travelsquad`
      axios.post(URL, {
        "from_admin":"1",
        "travel_squad": "1"
      })
      .then( data => {
        if(data.status === 200) {
          this.travel_squad = 1;
        }
      })
      .catch(error => {
        console.info(error);
      });
    },
    unactivateSquad() {
      const URL =`${process.env.API_URL}/api/client/${this.idUser}/travelsquad`
      axios.post(URL, {
        "from_admin":"1",
        "travel_squad": "0"
      })
      .then(data => {
        if(data.status === 200) {
          this.travel_squad = 0;
        }
      })
      .catch(error => {
        console.info(error);
      });
    },
  },
  computed: {
    filterColumns() {
      let activeFilterColumns = ["document_number", "email", "fullname", "cellphone"];
      return this.columns.filter((i) => activeFilterColumns.indexOf(i.name) > -1);
    },
  },
};
</script>

<style lang="css" scoped></style>



// WEBPACK FOOTER //
// ViajeComponent.vue?751b6cc2